<template>
  <div class="index">
    <div class="main-wrap">
      <div>
        <div class="wrapper">
          <jm-crumbs/>
          <div class="videoDescription">
            <div class="basic-title"><em>{{ formData.fileName }}</em></div>
            <el-form
              :model="formData"
              class="videoTable">

              <el-row>
                <el-col :pan="24">
                  <el-form-item>
                    说明内容 ：
                    <quill-editor
                      v-model="formData.description"
                      class="quillEditor452"
                      :options="editorOption"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="saveVideo"
                      class="btn-submit">确定</el-button>
                    <router-link
                      target="_blank"
                      :to="{ name: 'tasklist',params: { country: country}}">
                      <el-button
                        class="btn-return"
                        type="primary">返回</el-button>
                    </router-link>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
    .videoTable{
        margin-left: 35px;
    }
    .quillEditor452{
        height: 220px;
        width: 452px;
    }
    .btn-submit{
        margin-right: 10px;
        margin-top: 129px;
        margin-left: 143px;
    }
    .videoTable{
        margin-top: 52px;
    }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  data() {
    return {
      country: this.$route.params.country,
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video']
          ]
        }
      },
      formData: {
        description: '',
        fileName: '',
        fileUrl: ''
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    quillEditor
  },
  methods: {
    getVideoInfo() {
      let taskId = this.$route.params.taskId;
      this.$http._get({
        url: `/index/Task/getVideoInfo?taskId=${taskId}`
      }).then(({ data }) => {
        console.log(data);
        this.formData.fileName = data.file_name;
        this.formData.fileUrl = data.file_url;
        this.formData.description = data.title;
      });
    },
    saveVideo: function () {
      let data = {
        taskId: this.$route.params.taskId,
        title: this.formData.description,
        tpl_url: this.formData.fileUrl,
      };
      this.$http
        ._post({
          url: '/index/Task/saveVideo',
          data: data,
        })
        .then((data) => {
          if (data.result === 0) {
            this.$message.success('操作成功');
            this.getVideoInfo();
          }
        });
    }
  },
  mounted() {
    this.getVideoInfo();
  }
};
</script>
